import { Loading } from 'element-ui'

export const Load = {
  open (option) {
    const instance = Loading.service(option)
    this.instancePool.push(instance)
  },
  close () {
    if (this.instancePool.length <= 0) return
    this.instancePool[0].close()
    this.instancePool.shift()
  },
  instancePool: []
}
